<template>
    <tenancies-find
        :params="{ tenancy: $route.params.tenancy }"
        @success="onTenanciesFindSuccess"
    >
        <div
            slot-scope="{
                data: tenancy,
                error: find_error,
                is_loading,
                has_loaded,
                find
            }"
            :class="has_loaded ? 'bg-white rounded shadow' : ''"
        >
            <template v-if="!has_loaded || find_error">
                <base-loading
                    :error="find_error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="find_error"
                    :error="find_error"
                />
            </template>

            <template v-else>
                <header class="flex items-center px-4 border-b h-18 sm:px-6">
                    <h1 class="flex-grow text-lg font-normal">Enable Smart Payments</h1>

                    <div class="flex-none w-6 h-6 mr-3">
                        <base-svg
                            name="icon-lock"
                            class="w-full h-full"
                        />
                    </div>
                </header>

                <auto-payments-store @success="onSuccess">
                    <base-form
                        slot-scope="{
                            sid,
                            is_loading: is_saving,
                            data: auto_payment,
                            error: store_error,
                            store
                        }"
                        @submit="store(form)"
                    >
                        <div class="px-4 pt-6 border-b sm:px-6">
                            <validator-alert :sid="sid" />

                            <form-section>
                                <template slot="title">Method</template>
                                <template slot="description">
                                    How would you like to pay?
                                </template>

                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="bank_card"
                                >
                                    <template slot="label">Bank Card</template>

                                    <input-bank-card
                                        v-model="form.bank_card"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        name="bank_card"
                                    />

                                    <template slot="hint">
                                        Want to add a
                                        <router-link
                                            :to="{
                                                name: $router.fix('dashboard.*.bank-cards.create')
                                            }"
                                            class="text-blue"
                                        >
                                            new bank card?
                                        </router-link>
                                    </template>
                                </form-item>
                            </form-section>
                        </div>

                        <div class="px-4 pt-6 border-b sm:px-6">
                            <form-section>
                                <template slot="title">Amount</template>
                                <template slot="description">
                                    What's the <strong>maximum</strong> you would like to smart pay each month?
                                </template>

                                <grid-layout>
                                    <grid-layout-item class="md:w-1/2">
                                        <form-item
                                            :sid="sid"
                                            :is-required="true"
                                            name="amount"
                                        >
                                            <template slot="label">Amount</template>

                                            <div class="relative">
                                                <input-text
                                                    v-model="form.amount"
                                                    :sid="sid"
                                                    :disabled="is_saving"
                                                    type="tel"
                                                    name="amount"
                                                    class="pl-7"
                                                />
                                                <div class="absolute inset-y-0 left-0 flex items-center px-3 pt-1 margin-px text-grey-darker">
                                                    &pound;
                                                </div>
                                            </div>
                                        </form-item>
                                    </grid-layout-item>
                                </grid-layout>
                            </form-section>
                        </div>

                        <div class="px-4 py-3 text-right bg-grey-bg sm:px-6">
                            <base-button
                                :is-loading="is_saving"
                                class="w-full btn-blue md:w-auto"
                            >
                                Enable Smart Payments
                            </base-button>
                        </div>

                        <error-modal
                            v-if="store_error && $error.is(store_error, { exclude: [422] })"
                            :error="store_error"
                        />

                        <modal-success :is-open="show_created_modal">
                            <template slot="heading">Smart Payments Enabled!</template>

                            <p>
                                Smart payments have been successfully enabled. You can disable them at any
                                time from the tenancy screen.
                            </p>

                            <div
                                slot="footer"
                                class="flex flex-col md:flex-row-reverse"
                            >
                                <router-link
                                    :to="{
                                        name: $router.fix('dashboard.*.tenancies.show'),
                                        params: {
                                            tenancy: tenancy.uuid
                                        }
                                    }"
                                    class="text-center btn btn-green"
                                >
                                    Go to Tenancy
                                </router-link>
                            </div>
                        </modal-success>
                    </base-form>
                </auto-payments-store>
            </template>
        </div>
    </tenancies-find>
</template>

<script>
    import AutoPaymentsStore from '../../../../../components/auto-payments-store'
    import InputBankCard from '../../../../../components/input-bank-card'
    import TenanciesFind from '../../../../../components/tenancies-find'

    export default {
        components: {
            AutoPaymentsStore,
            InputBankCard,
            TenanciesFind
        },
        data () {
            return {
                show_created_modal: false,
                form: {
                    amount: '0',
                    payable: {
                        object: null,
                        uuid: null
                    },
                    bank_card: null
                }
            }
        },
        methods: {
            onSuccess ({ data: payment }) {
                this.$track(
                    'dashboard.tenants.tenancies.auto-payments.create',
                    'form-submission',
                    'A tenant has enabled auto payments.'
                )

                setTimeout(() => {
                    this.show_created_modal = true
                }, 0)
            },
            onTenanciesFindSuccess ({ data: tenancy }) {
                this.form.amount = (tenancy.amount / 100).toString()
                this.form.payable.object = tenancy.object
                this.form.payable.uuid = tenancy.uuid
            }
        }
    }
</script>
